import request from '@/utils/queryIccidRequest'

const channelApi = {
    sendChannelEmailVerifyCode: '/tsim/sale_info_collection/sendChannelEmailVerifyCode',
    becomeChannel: '/tsim/sale_info_collection/becomeChannel',
    sendSupplierEmailVerifyCode: '/tsim/sale_info_collection/sendSupplierEmailVerifyCode',
    becomeSupplier: '/tsim/sale_info_collection/becomeSupplier',
    getCountry: '/tsim/sale_info_collection/getCountry',
  }

  export const getCountry = (parameter) =>
    request({ 
    url: channelApi.getCountry, 
    method: "get" ,
    params: parameter
});

  export const becomeSupplier = (parameter) =>
    request({ 
    url: channelApi.becomeSupplier, 
    method: "post" ,
    data: parameter
});

  export const sendSupplierEmailVerifyCode = (parameter) =>
    request({ 
    url: channelApi.sendSupplierEmailVerifyCode, 
    method: "post" ,
    data: parameter
});

export const becomeChannel = (parameter) =>
  request({ 
  url: channelApi.becomeChannel, 
  method: "post" ,
  data: parameter
});

export const sendChannelEmailVerifyCode = (parameter) =>
    request({ 
    url: channelApi.sendChannelEmailVerifyCode, 
    method: "post" ,
    data: parameter
});